import _ from 'lodash'
import React, {useCallback,} from 'react'
import {getResponseItem, LoadingWrapper} from '../../Shared'
import {bindQueryParam, mapPathParam} from '../functions/routerHelper'
import {religiousOrder_getById_Api} from "../../../apis";
import useAsync from "../../../modules/asyncCache/useAsync";
import {PermissionEntity} from "../Permissions/PermissionEntity";
import ReligiousOrderEntity from "./ReligiousOrderEntity";
import {getId} from "../../../apis/model/base";

const ReligiousOrderContext = React.createContext({})

export const ReligiousOrderProvider = ({
                                         item,
                                         children,
                                         ...props
                                       }) => {

  const apiInfo = religiousOrder_getById_Api

  const id = getId(item) || item

  const cacheId = mapPathParam(apiInfo.path, {id})

  const {response, isLoading = false} = useAsync({
    apiInfo,
    query: bindQueryParam({id}),
  })

  const isSucceed = Number(_.get(response, 'status')) === 200

  const cache = getResponseItem(response)

  const error = getResponseItem(response, 'error')

  const errorMessage = _.get(response, 'errorMessages.error')

  const error_code = _.get(response, 'errorMessages.error_code')

  const status = {
    title: getResponseItem(response, 'status'),
    description: errorMessage,
  }


  const renderHeader = useCallback((action, isModal) => null, [])

  return (
    <LoadingWrapper isLoading={!item}>
      <ReligiousOrderEntity
        key={cacheId}
        item={id}>
        {(item) => {

          return (
            <PermissionEntity item={item}>
              <ReligiousOrderContext.Provider
                value={{
                  id,
                  isLoading,
                  item,
                  error,
                  cache,
                  status,
                  isSucceed,
                  error_code,
                  renderHeader,
                  errorMessage,
                  ...props,
                }}>
                {children}
              </ReligiousOrderContext.Provider>
            </PermissionEntity>
          )
        }}
      </ReligiousOrderEntity>
    </LoadingWrapper>
  )
}

export default ReligiousOrderContext
